import { initComponent } from './core/init-component';

initComponent('.js-footer-logo', (el) => {
  const magnetic = el.querySelector<HTMLElement>('.footer-logo-magnetic');
  const reveal   = el.querySelector<HTMLElement>('.footer-logo-reveal');
  const isHover  = window.matchMedia('(hover: hover)').matches;

  const getHiddenAmount = (): number => {
    if (!magnetic || !reveal) return 0;
    const imgs = Array.from(magnetic.querySelectorAll<HTMLImageElement>('img'));
    const img  = imgs.find(i => getComputedStyle(i).display !== 'none') ?? imgs[0];
    if (!img) return 0;
    const imgH = img.getBoundingClientRect().height;
    const pt   = parseFloat(getComputedStyle(reveal).paddingTop);
    return Math.max(0, imgH - (el.clientHeight - pt));
  };

  // Scroll reveal — all devices.
  // On mobile (no hover): slide the logo up when it enters the viewport.
  const observer = new IntersectionObserver(
    ([entry]) => {
      el.classList.toggle('is-revealed', entry.isIntersecting);

      if (!isHover && magnetic) {
        if (entry.isIntersecting) {
          magnetic.style.transition = 'transform 0.3s ease 0.2s';
          magnetic.style.transform  = `translateY(-${getHiddenAmount()}px)`;
        } else {
          magnetic.style.transition = '';
          magnetic.style.transform  = '';
        }
      }
    },
    { threshold: 0.3 }
  );
  observer.observe(el);

  // Magnetic reveal — desktop (hover-capable) only.
  if (!isHover || !magnetic) {
    return { unload: () => observer.disconnect() };
  }

  let hiddenAmount = 0;
  const updateHidden = () => { hiddenAmount = getHiddenAmount(); };
  updateHidden();
  window.addEventListener('resize', updateHidden);

  const xRange = 20; // ±20 px horizontal magnetic feel

  const onMouseMove = (e: MouseEvent) => {
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    // Horizontal: classic magnetic drift
    const tx = (x / rect.width) * (xRange * 2) - xRange;
    // Vertical: bipolar — top half moves logo up (reveals bottom), bottom half moves down
    const ty = (y / rect.height) * (hiddenAmount * 2) - hiddenAmount;
    magnetic.style.transform = `translate(${tx}px, ${ty}px)`;
  };

  const onMouseLeave = () => {
    magnetic.style.transform = '';
  };

  el.addEventListener('mousemove', onMouseMove);
  el.addEventListener('mouseleave', onMouseLeave);

  return {
    unload: () => {
      observer.disconnect();
      window.removeEventListener('resize', updateHidden);
      el.removeEventListener('mousemove', onMouseMove);
      el.removeEventListener('mouseleave', onMouseLeave);
    },
  };
});
